// Google İşletme Profili; takip parametreleri (authuser, skid…) bilerek atıldı.
export const MAPS_URL =
  'https://www.google.com/maps/place/Yeniden+Teknoloji+Anonim+%C5%9Eirketi/@41.0682147,28.6980245,17z/data=!3m1!4b1!4m6!3m5!1s0x216ba578766c3b97:0x69cddcd91b5af50c!8m2!3d41.0682147!4d28.7006048!16s%2Fg%2F11zy39vhcs';

export const MAPS_EMBED_URL =
  'https://maps.google.com/maps?q=Yeniden+Teknoloji+Anonim+%C5%9Eirketi&ll=41.0682147,28.7006048&z=17&output=embed';

export const SOCIAL_LINKS = [
  { label: 'Instagram', href: 'https://www.instagram.com/yenidenco' },
  { label: 'Facebook', href: 'https://www.facebook.com/yenidenco' },
  { label: 'TikTok', href: 'https://www.tiktok.com/@yenidenco' },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/company/yenidenco' },
] as const;
